var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.45,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#EC516E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 12H26V11C26 10.4 25.6 10 25 10C24.4 10 24 10.4 24 11V12H16V11C16 10.4 15.6 10 15 10C14.4 10 14 10.4 14 11V12H13C11.3 12 10 13.3 10 15V16H30V15C30 13.3 28.7 12 27 12ZM10 27C10 28.7 11.3 30 13 30H27C28.7 30 30 28.7 30 27V18H10V27ZM25 20C25.6 20 26 20.4 26 21C26 21.6 25.6 22 25 22C24.4 22 24 21.6 24 21C24 20.4 24.4 20 25 20ZM25 24C25.6 24 26 24.4 26 25C26 25.6 25.6 26 25 26C24.4 26 24 25.6 24 25C24 24.4 24.4 24 25 24ZM20 20C20.6 20 21 20.4 21 21C21 21.6 20.6 22 20 22C19.4 22 19 21.6 19 21C19 20.4 19.4 20 20 20ZM20 24C20.6 24 21 24.4 21 25C21 25.6 20.6 26 20 26C19.4 26 19 25.6 19 25C19 24.4 19.4 24 20 24ZM15 20C15.6 20 16 20.4 16 21C16 21.6 15.6 22 15 22C14.4 22 14 21.6 14 21C14 20.4 14.4 20 15 20ZM15 24C15.6 24 16 24.4 16 25C16 25.6 15.6 26 15 26C14.4 26 14 25.6 14 25C14 24.4 14.4 24 15 24Z",
    fill: "#EC516E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c60791e2e1e6715477c7577fe0d453da.svg";
export { ForwardRef as ReactComponent };